import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import {
  Warning as WarningIcon,
  Close as CloseIcon,
} from '@mui/icons-material';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ pb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <WarningIcon sx={{ fontSize: 28, color: 'warning.main', mr: 1 }} />
            <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
              スカウトメール受信設定
            </Typography>
          </Box>
          {!loading && (
            <IconButton onClick={onClose} sx={{ color: 'text.secondary' }}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
          スカウトメールを受信しない設定に変更しますか？
        </Typography>

        <Box
          sx={{
            p: 2,
            backgroundColor: 'warning.light',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'warning.main',
          }}
        >
          <Typography variant="body2" sx={{ color: 'warning.dark' }}>
            <strong>注意：</strong>
            スカウトメール受信を無効にすると、企業からの採用関連メッセージを受け取ることができなくなります。
            就職活動の機会を逃す可能性があります。
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
          ※ この設定はいつでも変更できます
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          sx={{ mr: 1 }}
        >
          キャンセル
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          color="warning"
        >
          {loading ? '設定中...' : '受信しない設定にする'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
